// Support contact for a causa the PJUD does not return: the same prefilled
// text for WhatsApp and email, with the content encoded.
import { SUPPORT_EMAIL } from '@/app/constants.js';

/**
 * @param {{text: string, subject: string, whatsappNumber?: string|null}} p
 * @returns {{whatsapp: string|null, mailto: string}}
 */
export function supportLinks({ text, subject, whatsappNumber }) {
  return {
    whatsapp: whatsappNumber
      ? `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`
      : null,
    mailto: `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(text)}`,
  };
}
